import { getToken } from "../../../utils/auth";
import { dev_baseUrl } from "../../../utils/var";

export const DeleteJobMiscCost = async (miscCostID, jobID, navigate) => {
  const accesstoken = getToken();

  if (accesstoken) {
    try {
        const queryParams = new URLSearchParams({
            miscCostID,
            jobID
            }).toString();
      const response = await fetch(`${dev_baseUrl}/JobMiscCost/delete?${queryParams}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${accesstoken}`,
          'Content-Type': 'application/json',
        },
      });
      
      const data = await response.json();        

    if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
        navigate(`/login`);
    } else if(response.ok && !data.isError ){      
      return data;
    } 
    else {
      console.error('Server Error:',data.message);
      return data;
    }
    } catch (error) {
      console.error('Network error:', error);
      return { form: 'An error occurred. Please try again later.' };
    }
  } else {
    console.warn('Access token is not available.');
    return { form: 'Access token is missing.' };
  }
};

export const SoftDeleteService = async (id,navigate) => {
    const accesstoken = getToken();
  
    if (accesstoken) {
      try {
        const response = await fetch(`${dev_baseUrl}/Service/softDelete/${id}`, {
          method: 'DELETE',
          headers: {
            'Authorization': `Bearer ${accesstoken}`,
            'Content-Type': 'application/json',
          },
        });
        
        const data = await response.json();        
  
      if (!response.ok && !data.isError && data.statusCode === "Unauthorized") {
          navigate(`/login`);
      } else if(response.ok && !data.isError ){      
        return data;
      } 
      else {
        console.error('Server Error:',data.message);
        return data;
      }
      } catch (error) {
        console.error('Network error:', error);
        return { form: 'An error occurred. Please try again later.' };
      }
    } else {
      console.warn('Access token is not available.');
      return { form: 'Access token is missing.' };
    }
};